import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getAboutUsInfo } from '../../http/home'
// @ts-ignore
import HtmlToReactParser from "html-to-react";

export const AboutUs: React.FC = () => {
  const [ aboutUsStr, setAboutUsStr ] = useState('');
  useEffect(()=> {
    getList();
    return;
  }, [])
  const getList = ()=> {
    getAboutUsInfo({}).then((res:any)=> {
      setAboutUsStr(res.data[0].content)
    }).catch((e) => {
        console.log("error:"+e.message)
    })
  }
  return (
      <Wrapper>
          <div className="main-container">
              {HtmlToReactParser.Parser().parse(aboutUsStr)}
          </div>
      </Wrapper>
  );
}
const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #DEDEDE;
    padding: 15px 0;
    overflow-y: auto;
    .main-container {
      margin: 0 auto;
      padding: 12px 24px;
      flex: 1;
      width: 70%;
      background: #fff;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      img {
        max-width: 100%;
      }
    }
  }
`